export default __webpack_public_path__ + "static/media/2930 utensils side.44a70199.png";